// extracted by mini-css-extract-plugin
export default {"period":"periodInfo_period__aR1m3","content":"periodInfo_content__4GK-V"};